import Serializable from "@/core/misc/mixins/Serializable";

class RpcDataPagination extends Serializable {
    /** Включена ли пагинация для запроса */
    isEnabled: boolean | null;
    /** Количество элементов на странице */
    limit: number | null;
    /** Смещение от начала списка */
    offset: number | null;
    /** Общее количество элементов */
    total: number | null;
    /** Была ли использована пагинация в запросе */
    isUsed: boolean | null;

    static createDefault(): RpcDataPagination {
        const obj  = new this();
        obj.limit  = 25;
        obj.offset = 0;
        return obj;
    }

    // допустим мы ищем продукт по вхождению, мне нужно отправить поисковой запрос на который
    // мне вернётся разумное кол-во айтемов, а не лист из 12 000 айтемов. Разумное число это 8
    static createForSearch(): RpcDataPagination {
      const result = RpcDataPagination.createDefault();
      result.limit = 8;
      return result;
    }

    /**
     * Пагинация выключена. Нужна там, где список обязан приехать целиком:
     * дерево категорий строит иерархию, и обрезанный ответ молча даст
     * категории без родителей. Не передать пагинацию вовсе нельзя - тогда
     * применится умолчание с лимитом.
     */
    static createDisabled(): RpcDataPagination {
      const result = new this();
      result.isEnabled = false;
      return result;
    }

    static fromRequest(data: Partial<RpcDataPagination>): RpcDataPagination|null {
        if (!data?.limit) {
            return null;
        }

        const obj = new this();

        if (data.isEnabled !== undefined) obj.isEnabled = data.isEnabled;
        if (data.limit !== undefined) obj.limit = data.limit;
        if (data.offset !== undefined) obj.offset = data.offset;

        return obj;
    }
}

export default RpcDataPagination;